import { graphql } from 'gatsby';
import _ from 'lodash';
import get from 'lodash/get';
import React, { Fragment } from 'react';

import { getPathFromModel } from '../utils/link';
import { getSchema } from '../utils/schema';

import BlockImage from '../components/article/block-image';
import Detail from '../components/article/detail';
import Hero from '../components/news/hero';
import BlockLinkList from '../components/shared/block-link-list';
import SEO from '../components/shared/seo';


export const query = graphql`
	query ArticleQuery($slug: String!, $category: String!) {
		settings:site {
			siteMetadata {
				siteUrl
			}
		}
		site:datoCmsSite {
			name
			globalSeo {
				siteName
			}
			faviconMetaTags {
				...GatsbyDatoCmsFaviconMetaTags
			}
		}
		page:datoCmsArticle(slug: { eq: $slug }){
			...ArticleFragment
			relatedArticles {
				model {
					apiKey
				}
				slug
				title
				introduction
				topic {
					name
				}
				category {
					name
				}
				banner {
					gatsbyImageData(
						layout: CONSTRAINED,
						placeholder: NONE,
						width: 400,
						imgixParams: {fit: "crop", w: "800", h: "600", crop: "focalpoint"}
					)
					alt
				}
			}
		}

		related:allDatoCmsArticle(filter: {category: {name: {eq: $category }}}, sort: {date: DESC}, limit: 3) {
			nodes {
				model {
					apiKey
				}
				slug
				title
				introduction
				topic {
					name
				}
				category {
					name
				}
				banner {
					gatsbyImageData(
						layout: CONSTRAINED,
						placeholder: NONE,
						width: 400,
						imgixParams: {fit: "crop", w: "800", h: "600", crop: "focalpoint"}
					)
					alt
				}
			}
		}
	}
`

const ArticlePage = ({ data, location, pageContext }) => {
	const settings = get(data, "settings.siteMetadata");
	const site = get(data, "site");
	const page = get(data, "page");
	const related = get(data, "related");

	if (!page || !settings || !site) return null;

	const schema = getSchema({ settings, site, page });

	let relatedArticles = page.relatedArticles.slice();
	if (relatedArticles.length === 0) {
		relatedArticles = related.nodes;
	} else {
		relatedArticles = _.unionBy(page.relatedArticles, related.nodes, 'title');
	}

	relatedArticles = relatedArticles.map((item) => {
		return {
			...item,
			label: item.category.name,
			description: item.introduction,
		};
	});

	const pageURL = `${settings.siteUrl}${getPathFromModel({ model: page.model, slug: page.slug })}`;

	return (
		<Fragment>
			<SEO tags={page.seoMetaTags} favicon={site.faviconMetaTags} siteURL={settings.siteUrl} pagePath={getPathFromModel({ model: page.model, slug: page.slug })} schema={schema} />
			<Hero title={page.title} isWithImage={page.banner} label={page.topic.name} banner={page.banner} dark={true} />
			{page.banner && <BlockImage {...page} />}
			<Detail {...page} pageURL={pageURL} />
			<BlockLinkList label="Need more?" bigText="Read More" items={relatedArticles.slice(0, 3)} spaceBefore={true} />
		</Fragment>
	)
}

ArticlePage.query = query;

export default ArticlePage;